module.exports = __webpack_public_path__ + "static/img/logos_220px_qidian.e5b268a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/network/logos_220px_qidian.png
// module id = dNjZ
// module chunks = 0